import React, { useEffect, useRef } from 'react';
import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import storage from 'src/utils/storageUtils';
import toast from 'src/utils/toast';

const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID; // We need this in frontend .env

function EmbeddedSignup({ clinicId, onConnectSuccess }) {
  const sessionInfoRef = useRef({});

  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function() {
      window.FB.init({
        appId            : FACEBOOK_APP_ID || '1296689659068968', // Active Meta App ID
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v18.0'
      });
    };

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    const handleMessage = (event) => {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      ) {
        return;
      }
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data && data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH' && data.data) {
            sessionInfoRef.current = {
              wabaId: data.data.waba_id,
              phoneNumberId: data.data.phone_number_id
            };
          }
        }
      } catch (e) {}
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const launchWhatsAppSignup = () => {
    if (!window.FB) {
      toast.error('Facebook SDK not loaded. Please try again.');
      return;
    }

    // Login configuration
    window.FB.login((response) => {
      if (response.authResponse) {
        const code = response.authResponse.accessToken; // FB login returns accessToken by default
        sendCodeToBackend(code);
      } else {
        console.log('User cancelled login or did not fully authorize.');
        toast.error('Login cancelled');
      }
    }, {
      scope: 'business_management,whatsapp_business_management,whatsapp_business_messaging'
    });
  };

  const sendCodeToBackend = async (code) => {
    try {
      const payload = {
        code,
        clinicId,
        wabaId: sessionInfoRef.current.wabaId,
        phoneNumberId: sessionInfoRef.current.phoneNumberId
      };
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/whatsapp/connect`,
        payload,
        { headers: { Authorization: `Bearer ${storage.get('TOKEN')}` } }
      );
      toast.success('Successfully connected to WhatsApp');
      if (onConnectSuccess) onConnectSuccess(res.data);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to connect WhatsApp');
      console.error(err);
    }
  };

  return (
    <Button 
      variant="contained" 
      onClick={launchWhatsAppSignup}
      sx={{
        bgcolor: '#1877F2', // Facebook Blue
        color: '#fff',
        '&:hover': { bgcolor: '#166fe5' },
        px: 4,
        py: 1.5,
        borderRadius: '8px',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: '16px'
      }}
    >
      Connect with Facebook
    </Button>
  );
}

export default EmbeddedSignup;
